// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gt_UOn3o2jIA73P2_FJg{padding-bottom:40px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/ui/ModalHeader/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA","sourcesContent":[".wrap {\n  padding-bottom: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `gt_UOn3o2jIA73P2_FJg`
};
export default ___CSS_LOADER_EXPORT___;
